// Система управления адресами куда стучаться в какой ситуации

export function getProtocolUrl() {
  const protocolsApi = 'https://nodeprotocols.vmmm.ru/api/'
  const protocolsApiTest = 'https://testnodeprotocols.vmmm.ru/api/'
  const protocolsLocal = 'http://localhost:5000/api/'
  const current = localStorage.getItem('protocols')
  const get = (current) => {
    switch (current) {
      case '0':
        return protocolsLocal
      case '1':
        return protocolsApi
      case '2':
        return protocolsApiTest
      default:
        return protocolsApi
    }
  }
  if (document.location.href.indexOf('localhost') != -1) {
    return get(current)
  }

  if (document.location.href.indexOf('test.vmmm.ru') != -1) {
    return protocolsApiTest
  }

  if (document.location.href.indexOf('lk.finexpert.pro') != -1) {
    return protocolsApi
  }

  return protocolsApi
}

export function getBackendUrl() {
  const backApiTest = 'https://t.finexpert.pro'
  const backApi = 'https://backend.vmmm.ru'
  const backLocal = 'http://localhost:8081'

  const current = localStorage.getItem('backend')
  const get = (current) => {
    switch (current) {
      case '0':
        return backLocal
      case '1':
        return backApi
      case '2':
        return backApiTest
      default:
        return backApi
    }
  }

  if (document.location.href.indexOf('localhost') != -1) {
    return get(current)
  }

  if (document.location.href.indexOf('test.vmmm.ru') != -1) {
    return backApiTest
  }

  if (document.location.href.indexOf('lk.finexpert.pro') != -1) {
    return backApi
  }

  return backApi
}

export function getReportUrl() {
  const reportLocal = 'http://localhost:4000/'
  const reportApi = 'https://report.vmmm.ru/'

  const current = localStorage.getItem('report')
  const get = (current) => {
    switch (current) {
      case '0':
        return reportLocal
      case '1':
        return reportApi
      default:
        return reportApi
    }
  }

  if (document.location.href.indexOf('localhost') != -1) {
    return get(current)
  }

  if (document.location.href.indexOf('test.vmmm.ru') != -1) {
    return reportApi
  }
  if (document.location.href.indexOf('lk.finexpert.pro') != -1) {
    return reportApi
  }

  return reportApi
}

export function getStorageUrl() {
  const dev = 'http://localhost:2000/'
  const prod = 'https://file.finexpert.pro/'
  const current = localStorage.getItem('store')

  const get = (current) => {
    switch (current) {
      case '0':
        return dev
      default:
        return prod
    }
  }

  if (document.location.href.indexOf('localhost') != -1) {
    return get(current)
  }

  return prod
}
